import { initVoteIntentController } from '../vote-intent-controller';

function boot(): void {
  initVoteIntentController();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

export {};
